import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { GeneralService } from '../../services/general.service';
import { UserModel } from '../../_models/_index';
import { RequestManagementService } from '../../services/request-management.service';
import { ApproveLoginComponent } from './approve-login/approve-login.component';
import { ForgotPasswordDialogComponent } from './forgot-password-dialog/forgot-password-dialog.component';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { LoginErrorEnum } from '../../_enums/login-error.enum';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    user: UserModel;
    loading = false;
    error = '';
    passwordLocal: string;

    constructor(private dialog: MatDialog,
        private generalService: GeneralService,
        private router: Router,
        private requestManagementService: RequestManagementService, 
        private usersService: UserService) {
    }

    ngOnInit() {
        this.requestManagementService.loadConfiguration();
        this.user = new UserModel();
        this.usersService.logout();
        this.passwordLocal = null;

    }

    getUser(id: number) {
        let u = new UserModel();
        u.id = id;
        this.usersService.getUser(u).then(result => {
            this.user = result;
          
                if (this.user.phoneNo) {
                    this.sendCodeOnLogin();
                }
                else {
                    this.loading = false;
                    this.generalService.showErrorDialog("לא הוגדר מספר טלפון");
                }
        }, (error) => {
            this.loading = false;
            this.error = "לא ניתן להתחבר לשרת, נסה שוב מאוחר יותר.";
        });
    }

    login() {
        this.loading = true;
        this.user.password = this.passwordLocal;
        this.usersService.authenticate(this.user).then(result => {
            let message;
            if (result) {
                this.loading = false;
                if (result.hasError) {
                    switch (+result.errorID) {
                        case LoginErrorEnum.NotValid:
                            message = "משתמש לא תקין-פנה למנהל המערכת";
                            break;
                        case LoginErrorEnum.PasswordExpired:
                            message = "תוקף סיסמא פג";
                            break;
                        case LoginErrorEnum.PasswordNotValid:
                            message = "סיסמא לא נכונה";
                            break;
                        case LoginErrorEnum.BlockedUser:
                            message = "משתמש חסום";
                            break;
                        case LoginErrorEnum.NamePasswordEmpty:
                            message = "שם משתמש או סיסמא ריקים";
                            break;
                        case LoginErrorEnum.UserNotValid:
                            message = "משתמש לא תקין-פנה למנהל המערכת";
                            break;
                        default:
                            message = "תקלה לא מזוהה";
                            break;
                    }
                    
                    this.error = message;   
                    
                }
                else {
                    this.getUser(result.userID);
                }
            }
           
        }, (error) => {
            this.loading = false;
            this.error = "לא ניתן להתחבר לשרת, נסה שוב מאוחר יותר.";
        });
    }

    sendCodeOnLogin()
    {
        this.usersService.sendCodeOnLogin(this.user).then(result => {
            if (result) {
                this.user = result;
                this.openApproveDialog();
                this.loading = false;
            }
            else {
                this.error = 'תקלה בשליחת קוד למייל';
                this.loading = false;
            }
        });
    }

    clearError(): void {
        this.error = '';
    }

    openApproveDialog() {
        let dialogRef = this.dialog.open(ApproveLoginComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.user = this.user;
        dialogRef.afterClosed().subscribe((result: UserModel) => {
            if (result) {
                this.router.navigate(['/home/']);
                this.loading = false;
            }
        });
    }

    forgotPassword() {
        if (this.user.userName) {
            this.generalService.showConfirmDialog('האם לאפס סיסמא?').then(res => {
                
                if (res) {
                    this.loading = true;
                    this.usersService.forgotPassword(this.user).then(userResult => {
                        this.loading = false;
                        if (userResult) {
                            
                            this.openForgotPasswordDialog();
                        }
                        else {
                            this.generalService.showErrorDialog(' לא ניתן לבצע איפוס לסיסמא,משתמש לא קיים או חסום או שלא הוגדר מספר טלפון');
                        }
                    });
                }
            });
        }
    }

    openForgotPasswordDialog() {
        let dialogRef = this.dialog.open(ForgotPasswordDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.userName = this.user.userName;
        dialogRef.afterClosed().subscribe((result: UserModel) => {
            if (result) {
                this.user = result;
               
                this.openChangePasswordDialog();
                this.loading = false;
            }
        });
    }

    openChangePasswordDialog() {
        let dialogRef = this.dialog.open(ChangePasswordDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.user = this.user;
        dialogRef.afterClosed().subscribe((result: UserModel) => {
            //if (result) {

               // this.router.navigate(['/home/']);
                //this.loading = false;
            //}
            this.generalService.showInformationDialog('שינוי סיסמא התבצע בהצלחה!');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts